import { render, staticRenderFns } from "./forgetFirst.vue?vue&type=template&id=77dbbb68&"
import script from "./forgetFirst.vue?vue&type=script&lang=js&"
export * from "./forgetFirst.vue?vue&type=script&lang=js&"
import style0 from "./forgetFirst.vue?vue&type=style&index=0&id=77dbbb68&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports